import { CalendarDate } from '@ethsign/icons';
import { Button } from '@ethsign/ui';
import { shortenWalletAddress } from '@ethsign/utils-web';
import classNames from 'classnames';

import { Link } from 'react-router-dom';

import { StatusTag } from '@/components';
import { ContractItem, ContractType, ICurrentUser } from '@/types';
import { dateFormat, stringifyQueryString } from '@/utils';
type Props = ContractItem & { user: ICurrentUser };
const indexToColor = [
  { bg: 'bg-blue-25', color: 'text-blue-500' },
  { bg: 'bg-darkMatter-25', color: 'text-darkMatter-500' },
  { bg: 'bg-teal-25', color: 'text-teal-500' },
  { bg: 'bg-yellow-25', color: 'text-yellow-400' },
  { bg: 'bg-tangerine-25', color: 'text-tangerine-500' }
];
export function ContractCard(props: Props) {
  const { title, sentBy, status, date, id, recipients, sentByName, contractType, user } = props;
  const address = shortenWalletAddress(sentBy, 'shorter');
  const signers = recipients
    ?.filter((item) => item.role === 'signer')
    .map(({ nickName, address, email }) => ({
      nickName: nickName
        ? nickName?.split(' ').map((s: string) => s[0]?.toUpperCase())
        : (address || email || '-').slice(0, 2)
    }));
  const newSigners =
    signers?.length === 5
      ? signers
      : signers?.length > 5
      ? [...signers.slice(0, 4), { nickName: '+' + (signers.length - 4) }]
      : signers;
  const isVisualContract = contractType === ContractType.visual_contract;
  const isLinkSignContract = contractType === ContractType.link_sign_contract;
  const isSender = user?.address === sentBy || user?.displayAddress === sentBy;
  let query = stringifyQueryString({
    type: isSender && (isVisualContract || isLinkSignContract) ? 'view' : ''
  });
  query = query ? `?${query}` : '';

  return (
    <div className="flex-1 mr-4 border border-gray-200 rounded-lg last:mr-0 px-5 py-5 flex flex-col items-start overflow-hidden">
      <div className="flex flex-row justify-between  w-full overflow-hidden">
        <div className="flex-1 w-2 pr-3">
          <div className="text-sm font-semiBold font-semibold text-gra700  w-full truncate " title={title}>
            {title}
          </div>
          <div
            className="mt-1 text-sm font-normal text-gray-600  w-full truncate"
            title={sentByName ? `${sentByName}(${address})` : address}
          >
            <span className="text-gray-400">Sent by: </span>
            {sentByName ? `${sentByName}(${address})` : address}
          </div>
        </div>
        <Link to={`/contract/${id}${query}`} className="min-w-[98px]">
          {status === 'wait_me' && <Button size="sm">Sign Now</Button>}
          {status !== 'wait_me' && (
            <Button size="sm" variant="outline">
              {isVisualContract ? 'View All Now' : 'View Now'}
            </Button>
          )}
        </Link>
      </div>
      <div className="mt-3">
        <StatusTag status={status}></StatusTag>
      </div>
      <div className="w-full border-t border-gray-200 mt-3 "></div>
      <div className="mt-3 flex flex-row justify-between w-full items-center">
        <div className="flex flex-row items-center h-11 px-[18px] bg-primary-25 rounded-md">
          <CalendarDate size={20} color="#D97D40"></CalendarDate>
          <span className="ml-2 text-md font-medium text-gray-500">{dateFormat(date)}</span>
        </div>
        <div className="ml-4 ">
          {newSigners?.map((item, i) => (
            <span
              className={classNames(
                'inline-block w-8 h-8 rounded-full text-xs font-medium text-center leading-8 box-content border-[2px]  border-white mr-[-8px]',
                {
                  [indexToColor[i].bg]: true,
                  [indexToColor[i].color]: true
                }
              )}
              key={i}
            >
              {item.nickName}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
